import React from 'react'

export default function Window() {
    return (
        <div>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5521 47.9166H12.3521C11.4375 41.5332 6.38333 36.4791 0 35.5645V31.3645C8.68542 32.327 15.5896 39.2312 16.5521 47.9166ZM24.9208 47.9166H20.7396C19.7479 36.9291 10.9875 28.1687 0 27.177V22.9958C13.2875 24.0083 23.9083 34.6291 24.9208 47.9166ZM8.125 47.9166H0V39.7916C4.07917 40.6208 7.29583 43.8374 8.125 47.9166ZM50 47.9166H29.1667V43.7499H45.8333V12.4999H4.16667V18.7499H0V2.08325H50V47.9166Z" fill="#BB0600" />
            </svg>
        </div>
    )
}
